module.exports = __webpack_public_path__ + "static/img/WechatIMG390.9e45df3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/WechatIMG390.jpeg
// module id = sZTN
// module chunks = 0